import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ErrorAlertComponent } from "../../../ui/components/alerts/error/error.alert.component";
import { ConfirmAlertComponent } from "../../../ui/components/alerts/confirm/confirm.alert.component";
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
var AlertUtils = /** @class */ (function () {
    function AlertUtils(modalService) {
        this.modalService = modalService;
    }
    AlertUtils.prototype.showErrorAlert = function (title, message) {
        var modalRef = this.modalService.open(ErrorAlertComponent);
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
    };
    AlertUtils.prototype.showConfirmAlert = function (title, message, onConfirm, onClose) {
        var modalRef = this.modalService.open(ConfirmAlertComponent, { centered: true });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.result.then(function () {
            onConfirm();
        }, function () {
            onClose();
        });
    };
    AlertUtils.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AlertUtils_Factory() { return new AlertUtils(i0.ɵɵinject(i1.NgbModal)); }, token: AlertUtils, providedIn: "root" });
    return AlertUtils;
}());
export { AlertUtils };
